import React, { useState } from 'react';
import { Waypoint } from 'react-waypoint';
import { AnimatePresence, motion } from 'framer-motion';
import useMeasure from 'react-use/lib/useMeasure';
import { Wrapper, StickyWrapper } from './TopBar.styles';
import { BeFi20LogoText } from '../../../img/BeFi20LogoText';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { BeFi20Logo } from '../../../img/BeFi20Logo';

interface Props {
  clientId: number;
  isMobile?: boolean;
}

export const TopBar = ({ clientId, isMobile }: Props) => {
  const [isTopBarLogoVisible, setIsTopBarLogoVisible] = useState(false);

  const [topBarRef, { height: topBarHeight }] = useMeasure<HTMLDivElement>();

  return (
    <>
      <StickyWrapper ref={topBarRef}>
        <Wrapper>
          <Button
            variant="subtleActive"
            onClick={() => ADV.util.Router.go2('BeFi20Overview', { clientId })}
            leftIcon="fas fa-chevron-left"
          >
            {`My BeFi20${!isMobile ? ' Comparisons' : ''}`}
          </Button>

          <AnimatePresence>
            {isTopBarLogoVisible && (
              <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                style={{ lineHeight: 0 }}
              >
                <BeFi20LogoText />
              </motion.span>
            )}
          </AnimatePresence>
        </Wrapper>
      </StickyWrapper>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
        <BeFi20Logo />
      </motion.div>

      <Waypoint
        onEnter={() => setIsTopBarLogoVisible(false)}
        onLeave={() => setIsTopBarLogoVisible(true)}
        topOffset={topBarHeight}
      />
    </>
  );
};
